import { ApiService } from './api-service/api.service';
import { AuthService } from './auth/auth.service';
import { IPromise, IQService } from 'angular';
import * as moment from 'moment';

export interface IAccess {
  access?: boolean;
}

export class AccessService {
  static $inject = [
    'ApiService',
    'AuthService',
    '$q'
  ];
  showAccessInfoDialog: boolean;

  constructor( private apiService: ApiService,
               private authService: AuthService,
               private $q: IQService ) {
  }

  checkAccess(): IPromise<any> {
    if ( !this.authService.user ) {
      this.showAccessInfoDialog = false;
      return this.$q.resolve();
    }
    if ( this.authService.userRoles.isCandidate ) {
      return this.apiService.get<IAccess>('/user/checkAccess')
        .then(( data ) => {
          if ( data.access ) {
            this.showAccessInfoDialog = false;
          }
          return data.access;
        });
    } else if ( this.authService.userRoles.isEmployer ) {
      this.showAccessInfoDialog = false;
      return this.$q.resolve(true);
    }
    this.showAccessInfoDialog = false;
    return this.$q.resolve(true);
  }

  checkAccessTo(type: 'hasVesselType' | 'canChat' | 'createVacancy'): IPromise<boolean> {
    switch (type) {
      case 'hasVesselType': {
        return this.$q.resolve(true);
      }
      case 'canChat': {
        return this.$q.resolve(this.authService.user.plan.currentPlan.name !== 'Start' &&
          moment(this.authService.user.plan.expire_date)
            .isAfter(moment().endOf('d'))
        );
      }
      case 'createVacancy': {
        if (this.authService.user.plan.currentPlan.name === 'Start'
          && this.authService.user.use_demo_features) {
          return this.$q.resolve(false);
        } else if (moment(this.authService.user.plan.expire_date)
          .isBefore(moment().endOf('d'))) {
          return this.$q.resolve(false);
        }
        return this.$q.resolve(true);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./app/core/services/access.service.ts